// extracted by css-extract-rspack-plugin
module.exports =  {"container":"JobCards__container___OU8mU"};